(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .component('funnelColumnCard', {
            bindings: {
                column: '=',
                columns: '<',
                sortableOptions: '<',
                onDelete: '&',
                actions: '<',
            },
            controller: FunnelColumnCardController,
            controllerAs: 'vm',
            templateUrl: 'app/admin/sales-funnel/components/column-card/column-card.html'
        });

    /** @ngInject */
    function FunnelColumnCardController($timeout, $uibModal, $rootScope, $translate, SalesFunnelService, toastr, systemConstants, MODAL_CONTENT_TYPES, $window, $localStorage) {
        var vm = this;

        vm.isEditingName = false;
        vm.hasMoreNegotiations = true;
        vm.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MIN_SM;

        vm.columnActions = [
            {
                icon: 'icon-ksc-trash-regular',
                label: $translate.instant("salesFunnel.actions.delete"),
                disabled: vm.column.negotiations.length > 0 || vm.columns.length === 1,
                tooltip: $translate.instant("salesFunnel.actions.delete-not-allowed"),
                method: function () {
                    vm.deleteColumn();
                }
            }
        ];

        vm.editName = function () {
            vm.isEditingName = true;

            vm.previousTitle = vm.column.title;

            $timeout(function () {
                var inputElement = document.querySelector('.edit-column-input');
                if (inputElement) {
                    inputElement.focus();
                }
            });
        }

        vm.saveName = function () {
            if (!vm.column.title || !vm.column.title.trim()) {
                toastr.error($translate.instant('salesFunnel.error.emptyColumnName'));
                return;
            }

            vm.isEditingName = false;
            SalesFunnelService.updateStage(vm.column.id, { title: vm.column.title, position: vm.column.position, lastStage: vm.column.lastStage })
                .then(function () {
                    toastr.success($translate.instant('salesFunnel.success.updatedColumn'));
                    return SalesFunnelService.getCardWall();
                })
                .catch(function (error) {
                    if (!vm.column.title || !vm.column.title.trim()) {
                        toastr.error($translate.instant('salesFunnel.error.emptyColumnName'));
                        vm.column.title = vm.previousTitle;
                    }
                    if (error.data.data.fieldErrors[0].message === 'Size' && vm.column.title.trim()) {
                        toastr.error($translate.instant('salesFunnel.error.exceedsCharLimitError'));
                    } else {
                        toastr.error(error.message);
                    }
                    $timeout(function () {
                        vm.column.title = vm.previousTitle;
                    });
                });
        };

        vm.deleteColumn = function () {
            vm.onDelete({column: vm.column});
        }

        vm.loadMoreNegotiations = function () {
            SalesFunnelService.loadNegotiations(vm.column.id, vm.column.negotiations.length)
                .then(function (response) {
                    if (response.data && response.data.length > 0) {
                        vm.column.negotiations = vm.column.negotiations.concat(response.data);
                        if (response.data.length < 10) {
                            vm.hasMoreNegotiations = false;
                        }
                    } else {
                        vm.hasMoreNegotiations = false;
                    }
                })
                .catch(function (error) {
                    toastr.error(error.message);
                });
        };

        vm.openNegotiationSideMenu = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/modal/side-modal/side-modal.html',
                controller: 'SideModalController',
                windowClass: 'side-modal',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    content: function () {
                        return {
                            negotiationId: null,
                            column: angular.copy(vm.column),
                            columns: vm.columns,
                            isImmoContext: vm.isImmoContext || false,
                            title: $translate.instant('salesFunnel.label.negotiation'),
                            cancelButtonText: $translate.instant('salesFunnel.button.cancel'),
                            confirmButtonText: $translate.instant('salesFunnel.button.save'),
                            type: MODAL_CONTENT_TYPES.NEGOTIATION
                        }
                    }
                }
            });

            modalInstance.result.then(function (createdNegotiation) {
                vm.column.negotiations.unshift(createdNegotiation);
                $rootScope.$applyAsync();
            });
        }

        vm.formatMoney = function (value) {
            var currencyConfigurations = $localStorage.defaultStore.storeInfo.currencyConfiguration;
            if(!currencyConfigurations) {
                return
            }
            if (!value) {
                return;
            }
            return $translate.instant('salesFunnel.label.total') + formatMoney(value, currencyConfigurations.prefix, currencyConfigurations.decimalQuant,
                currencyConfigurations.centsSeparator, currencyConfigurations.thousandsSeparator);
        };
    }
})();

